import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-News-Information',
    templateUrl: './News-Information.component.html',
    styleUrls: ['./News-Information.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewsInformationComponent implements OnInit {
  status=false;
  constructor() { }

  ngOnInit() {
  }

}
